import React from "react";
import { Badge } from "@/components/ui/badge";

const MAP = {
  // participant / booking
  lead: { label: "Cliente potencial", cls: "bg-sky-100 text-sky-800 border-sky-200 dark:bg-sky-950 dark:text-sky-300" },
  interested: { label: "Interesado", cls: "bg-sky-100 text-sky-800 border-sky-200 dark:bg-sky-950 dark:text-sky-300" },
  deposit_pending: { label: "Depósito pendiente", cls: "bg-amber-100 text-amber-800 border-amber-200 dark:bg-amber-950 dark:text-amber-300" },
  deposit_paid: { label: "Depósito pagado", cls: "bg-emerald-100 text-emerald-800 border-emerald-200 dark:bg-emerald-950 dark:text-emerald-300" },
  confirmed: { label: "Confirmado", cls: "bg-sky-100 text-sky-800 border-sky-200 dark:bg-sky-950 dark:text-sky-300" },
  partial_paid: { label: "Pago parcial", cls: "bg-amber-100 text-amber-800 border-amber-200 dark:bg-amber-950 dark:text-amber-300" },
  fully_paid: { label: "Pago completo", cls: "bg-emerald-100 text-emerald-800 border-emerald-200 dark:bg-emerald-950 dark:text-emerald-300" },
  cancelled: { label: "Cancelado", cls: "bg-red-100 text-red-800 border-red-200 dark:bg-red-950 dark:text-red-300" },
  refunded: { label: "Reembolsado", cls: "bg-red-100 text-red-800 border-red-200 dark:bg-red-950 dark:text-red-300" },
  waitlist: { label: "Lista de espera", cls: "bg-sky-100 text-sky-800 border-sky-200 dark:bg-sky-950 dark:text-sky-300" },
  // tour
  full: { label: "Completado", cls: "bg-emerald-100 text-emerald-800 border-emerald-200 dark:bg-emerald-950 dark:text-emerald-300" },
  in_progress: { label: "En curso", cls: "bg-amber-100 text-amber-800 border-amber-200 dark:bg-amber-950 dark:text-amber-300" },
  finished: { label: "Finalizado", cls: "bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-800 dark:text-slate-300" },
  // Note: "confirmed" is intentionally handled by the participant/booking mapping above
  // (same key "confirmed" → emerald "Confirmado" label works for tours too).
  // task
  todo: { label: "Pendiente", cls: "bg-amber-100 text-amber-800 border-amber-200 dark:bg-amber-950 dark:text-amber-300" },
  doing: { label: "En curso", cls: "bg-sky-100 text-sky-800 border-sky-200 dark:bg-sky-950 dark:text-sky-300" },
  done: { label: "Hecho", cls: "bg-emerald-100 text-emerald-800 border-emerald-200 dark:bg-emerald-950 dark:text-emerald-300" },
  urgent: { label: "Urgente", cls: "bg-red-100 text-red-800 border-red-200 dark:bg-red-950 dark:text-red-300" },
  high: { label: "Alta", cls: "bg-amber-100 text-amber-800 border-amber-200 dark:bg-amber-950 dark:text-amber-300" },
  medium: { label: "Media", cls: "bg-sky-100 text-sky-800 border-sky-200 dark:bg-sky-950 dark:text-sky-300" },
  low: { label: "Baja", cls: "bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-800 dark:text-slate-300" },
};

// Overrides for hotel/transport confirmation status (kind="acc")
const ACC_MAP = {
  draft: { label: "Pendiente", cls: "bg-red-100 text-red-800 border-red-200 dark:bg-red-950 dark:text-red-300" },
  in_progress: { label: "Reservado", cls: "bg-sky-100 text-sky-800 border-sky-200 dark:bg-sky-950 dark:text-sky-300" },
  confirmed: { label: "Reservado y pagado", cls: "bg-emerald-100 text-emerald-800 border-emerald-200 dark:bg-emerald-950 dark:text-emerald-300" },
  cancelled: { label: "Cancelado", cls: "bg-red-100 text-red-800 border-red-200 dark:bg-red-950 dark:text-red-300" },
};

export default function StatusBadge({ value, label, kind }) {
  const source = kind === "acc" ? ACC_MAP : MAP;
  const cfg = source[value] || MAP[value] || { label: label || value, cls: "bg-slate-100 text-slate-700 border-slate-200" };
  return (
    <Badge data-testid={`status-badge-${value}`} variant="outline" className={`${cfg.cls} font-medium`}>
      {label || cfg.label}
    </Badge>
  );
}
